import quickview from './quickview/index';

class QuickViewRunner {
  constructor() {
    quickview.run();
  }
}

const quickViewRunner = new QuickViewRunner();



// WEBPACK FOOTER //
// ./assets/scripts/quickview.js